
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/contact-us",
      function () {
        return require("private-next-pages/es/contact-us.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/contact-us"])
      });
    }
  